// components/common/EntriesSelector.tsx
import React, { useState, useRef, useEffect } from "react";
import { IconChevronDown, IconChevronUp } from "@tabler/icons-react";

interface EntriesSelectorProps {
  value: number;
  options?: number[];
  onChange: (value: number) => void;
}

const EntriesSelector: React.FC<EntriesSelectorProps> = ({
  value,
  options = [10, 20, 50, 100],
  onChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);
 
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="flex items-center gap-2 text-sm" ref={wrapperRef}>
      <div className="relative">
        <button
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          className="flex items-center gap-1.5 border border-slate-200 bg-white rounded-lg px-3 py-1 cursor-pointer text-xs font-semibold text-slate-700 select-none h-8 shadow-sm hover:bg-slate-50 hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 active:scale-95 transition-all duration-150"
        >
          {value}
          {isOpen ? (
            <IconChevronUp strokeWidth={2.5} size={13} />
          ) : (
            <IconChevronDown strokeWidth={2.5} size={13} />
          )}
        </button>

        {isOpen && (
          <div className="absolute left-0 mt-2 w-full bg-white border border-slate-200 rounded-xl shadow-xl z-50 overflow-hidden divide-y divide-slate-100 animate-in fade-in duration-100 min-w-[50px]">
            {options.map((opt) => (
              <div
                key={opt}
                className={`px-3 py-2 cursor-pointer transition text-xs font-bold text-center select-none ${
                  opt === value
                    ? "bg-[#FBD037] text-[#131327]"
                    : "text-slate-600 hover:bg-slate-50 hover:text-slate-800"
                }`}
                onClick={() => {
                  onChange(opt);
                  setIsOpen(false);
                }}
              >
                {opt}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default EntriesSelector;
